export enum BrandApiMessages {
  BRAND_UPDATED = 'Brand Updated Successfully',
  BRAND_DELETED = 'Brand Deleted',
}
